export const ELLIPSIS = "...";

export type PaginationPage = number | typeof ELLIPSIS;

const MAX_PAGES = 8;

function range(start: number, end: number): number[] {
  const pages: number[] = [];
  for (let page = start; page <= end; page += 1) {
    pages.push(page);
  }
  return pages;
}

export default function getPaginationPages(
  current: number,
  pageSize: number,
  total: number,
): PaginationPage[] {
  if (!total) return [];

  const lastPage = Math.max(1, pageSize ? Math.ceil(total / pageSize) : 1);

  if (lastPage <= MAX_PAGES) {
    return range(1, lastPage);
  }

  if (current <= 4) {
    return [...range(1, 5), ELLIPSIS, lastPage];
  }

  if (current >= lastPage - 3) {
    return [1, ELLIPSIS, ...range(lastPage - 4, lastPage)];
  }

  return [1, ELLIPSIS, ...range(current - 1, current + 1), ELLIPSIS, lastPage];
}
